import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridMultiple, createGridConfig, gridSimple, gridDetail } from "./gridSettings/gridSettings";


export const CausaleRifiutiVociObbligatori: AnaColumn[] = [
  {
    itemType: "group", colCount: "1", data: [


      {
        type: 'campo', dataField: "idCampoDocumentoRifiuto", caption: 'idCampo',
        disableOnUpdate: true,

        allowEditing: false,
        showEditorAlways: false,
        colVisible: false

      },
      {
        type: 'campo', dataField: "descrizioneCampoDocumentoRifiuto", caption: 'Campo',
        showEditorAlways: false,
        allowEditing: false,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        class: '',
        colWidth: '530',
      },
      {
        type: 'campo', dataField: "movimento", caption: 'Movimento',

        allowEditing: true,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        colWidth: '90',
        editorType: 'dxSelectBox',

        lista: {
          dataSource: '',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true,
          items: [
            { id: 'A', descrizione: 'Avvisare' },
            { id: 'B', descrizione: 'Bloccare' }
          ]
        }

      },
      {
        type: 'campo', dataField: "documento", caption: 'XFIR',

        allowEditing: true,
        colVisible: true,
        disableOnUpdate: false,
        hideOnEdit: false,
        colWidth: '90',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: '',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true,
          items: [
            { id: 'A', descrizione: 'Avvisare' },
            { id: 'B', descrizione: 'Bloccare' }
          ]
        }

      },

    ]
  }

]

export const CausaliAvanzate: AnaColumn[] = [
  {
    configuration:
    {

      titleGriglia: 'Causali gestione rifiuti',
      titleForm: 'Configurazione causale $descCausale',
      campoTitle: ['descCausale'],
      helpDoc: 'Avanzate.html',

      service: 'CausaliAvanzate',
      api: 'CausaleRifiuti',
      filterList: '/',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 2,
      idTabRif: [
        {
          key: 'idCausale',
          value: 'id'
        },
        {
          key: 'descCausale',
          value: 'descrizione'
        },
        {
          key: 'idOperazione',
          value: 'idOperazione'
        },
        {
          key: 'trasporto',
          value: 'trasporto'
        },
        {
          key: 'escludiRegistri',
          value: 'escludiRegistri'
        },


      ],


    },
  },

  /* modifica 28-29/08/2023 
  {
    itemType: "group", colCount: '1', caption: "Impostazioni Varie", class: 'causale-rifiuti-avanzate', groupDataField: 'causaliAvanzateVarie', data: [

      {
        type: 'campo',
        dataField: 'anchereLazioniPercentuali',
        dataType: 'boolean',
        caption: 'Anche relazioni percentuali',
        editorType: 'dxCheckBox'

      },
      {
        type: 'campo',
        dataField: 'nonControllareHP',
        dataType: 'boolean',
        caption: 'Non controllare HP in fase di scarico',
        editorType: 'dxCheckBox'

      },

    ]
  }, */
  /* modifica 11-13/09/2023 */

  {
    itemType: "group", colCount: '1', caption: "Opzioni Avanzate", class: '', groupDataField: 'causaliAvanzate', data: [

      /*  {
         type: 'empty',
         caption: 'Proponi relazioni con le seguenti operazioni di carico',
        
         dataField: 'relazioniOperazioniCarico',
         colSpan: '1'
       },
  */
      {
        type: 'campo',
        dataField: 'scaricaDeposito',
        dataType: 'boolean',
        caption: 'Rifiuti prod.e messi in deposito temporaneo',
        editorType: 'dxCheckBox',
        labelWidth: 380,



      },
      {
        type: 'campo',
        dataField: 'scaricaRicevuti',
        dataType: 'boolean',
        caption: 'Rifiuti ricevuti da terzi ',
        editorType: 'dxCheckBox',
        labelWidth: 380,


      },

      {
        type: 'campo',
        dataField: 'scaricaRifiutiProdotti',
        dataType: 'boolean',
        caption: 'Rifiuti prod.e messi in Deposito Preliminare/Messa in riserva ',
        editorType: 'dxCheckBox',
        labelWidth: 380,


      },


      {
        type: 'empty',
        colSpan: '1',
        dataField: '',
        caption: ' '
      },

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'caricoAutomaticoRifiutiProdotti_Descrizione',
        dataType: "",
        labelWidth: 380,
        caption: 'Genera carico autom.rifiuti prodotti',
        disableOnUpdate: true,
        nCol: 10,
        dynamic: {
          dataSource: 'CausaleRifiuti',
          service: '',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Elenco causali di carico",
          filter: '',
          queryString: "?$filter=(idOperazione eq 'A1' or idOperazione eq 'A2')",
          componentType: 'dynamicGrid',
          related: ['id|caricoAutomaticoRifiutiProdotti'],

          buttonOption: {
            text: 'Elenco causali di carico scaricabili',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia causali di carico',
            name: 'stoccaggio',
            location: 'after',

          },

          settingGrid: createGridConfig(
            {
              ...gridSimple,

              colonne: [
                {
                  dataField: 'idOperazione',
                  dataType: '',
                  caption: 'Operazione',
                  allowEditing: false,
                  groupIndex: 0,
                  colSpan: 2,
                  lista: {

                    dataSource: 'OperazioneCausaleRIfiuti',
                    valueExpr: 'id',
                    displayExpr: 'descrizione',


                  },
                },


                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: '500',
                  hideOnEdit: false
                },



              ]

            }

          )




        }
      },




      {
        type: 'campo',
        dataField: 'caricoAutomaticoRifiutiDaLavorazione',
        dataType: 'boolean',
        caption: 'Carico auto.rifiuti prod.da lavorazione',
        editorType: 'dxCheckBox',

        labelWidth: 380
      },


      /* 
            {
              type: 'empty',
              colSpan: '1',
              dataField: 'Caricodamiscelazione_label',
              caption: 'Carico da miscelazione/rintracciabilità',
             
            }, */

      {
        type: 'campo',
        dataField: 'caricoDaMiscelazione',
        dataType: 'boolean',
        caption: 'Carico da miscelazione',
        editorType: 'dxCheckBox',
        labelWidth: 380,

      },
      {
        type: 'campo',
        dataField: 'attivaRintracciabilita',
        dataType: 'boolean',
        caption: 'Attiva Rintracciabilita',
        editorType: 'dxCheckBox',
        labelWidth: 380,

      },



      {
        type: 'campo',
        dataField: 'partecipaAllaMiscelazione',
        dataType: 'boolean',
        caption: 'Partecipa alla miscelazione',
        editorType: 'dxCheckBox',
        labelWidth: 380,

      },

    ]
  },
  /*modifica 28-29/08/2023{
    itemType: "group", visible: false, colCount: '1', caption: "Causali carico automatico di rifiuti prodotti o da lavorazione", class: 'causale-rifiuti-avanzate-carico-auto', groupDataField: 'causaliAvanzateLavorazione', data: [

      {
        type: 'campoSpecial', defaultValue: "", dataField: "listaCausaliCaricoAutomaticoRifiutiProdottiDesc", dataType: "", caption: "Carico automatico rif.prod.",
        maxLength: '60',
        hideOnEdit: true,
        disableOnUpdate: true,
        showInColumnChooser: false,
        editorClass: 'text-truncate',
        attr: 'width:90%',
        dynamic: {
          dataSource: 'CausaleRifiuti',
          service: '',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Elenco causali di carico  per carico automatico rifiuti prodotti",
          queryString: '',
          filter: '',
          filterStatic: "?$filter=(idOperazione eq 'A1' or idOperazione eq 'A2')",
          componentType: 'dynamicGrid',
          related: ['listaCausaliCaricoAutomaticoRifiutiProdotti'],
          buttonOption: {
            text: 'Elenco causali di carico scaricabili',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia causali di carico',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'id',
            keyUnique: 'id',
            selectionMode: 'multiple',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: true,
            searchAndSelectDataSource: 'OperazioneSmaltimento',
            showColBlank: false,
            outputData: false,
            height: 480,
            colonne: [
              {
                dataField: 'id',
                dataType: 'number',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true
              },

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',

                hideOnEdit: false
              },


            ]

          }

        }
      },
      {
        type: 'campoSpecial', defaultValue: "", dataField: "listaCausaliCaricoCaricoAutomaticoRifiutidaLavorazioneDesc", dataType: "", caption: "Carico automatico rif.prod.da lavoraz.",
        colSpan: '2',
        maxLength: '60',
        hideOnEdit: true,
        disableOnUpdate: true,
        width: '45%',
        editorClass: 'text-truncate',
        attr: 'width:90%',
        showInColumnChooser: false,
        dynamic: {
          dataSource: 'CausaleRifiuti',
          service: '',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Elenco causali di carico per carico automatico rifiuti prodotti da lavorazione",
          queryString: '',
          filter: '',
          filterStatic: "?$filter=(idOperazione eq 'A1' or idOperazione eq 'A2' and prodottoDaGestione eq 'S')",
          componentType: 'dynamicGrid',
          related: ['listaCausaliCaricoCaricoAutomaticoRifiutidaLavorazione'],
          buttonOption: {
            text: 'Elenco causali di carico scaricabili',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia causali di carico',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'id',
            keyUnique: 'id',
            selectionMode: 'multiple',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: true,
            searchAndSelectDataSource: 'OperazioneSmaltimento',
            outputData: false,
            showColBlank: false,
            height: 480,
            colonne: [
              {
                dataField: 'id',
                dataType: 'number',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true
              },

              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',

                hideOnEdit: false
              },


            ]

          }

        }
      },

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "listaCausaliCaricoAutomaticoRifiutiProdotti",
        hideOnEdit: true,
        labelVisible: false,
        dataType: "",
        caption: "",
        class: 'd-none',
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'CausaleRifiuti',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          displayExpr: '',
          related: ['descrizione|listaCausaliCaricoAutomaticoRifiutiProdottiDesc'],


        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "listaCausaliCaricoCaricoAutomaticoRifiutidaLavorazione",
        hideOnEdit: true,
        labelVisible: false,
        dataType: "",
        caption: "Mod. Stoccaggio ",
        class: 'd-none',
        disableOnUpdate: true,
        width: '45%',
        dynamic: {
          dataSource: 'CausaleRifiuti',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          displayExpr: '',
          related: ['descrizione|listaCausaliCaricoCaricoAutomaticoRifiutidaLavorazioneDesc'],

        }

      },

      


    ]
  },
   {
    itemType: "group", visible: false, colCount: '1', caption: "Elenco causali di carico scaricabili e ordinabili", class: 'lista-causali-scaricabili', groupDataField: 'causaliAvanzateScaricabili', data: [

      {
        type: 'campoSpecial',
        dataField: 'ordineCausali',
        dataType: 'boolean',
        caption: 'Ordina causali per data',
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [
            
            {
              icon: 'glyphicon icon-unlocked',
              value: true,
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: false,
              descrizione: 'No',
              alignment: 'center',
            },
          ]
        }

      },

      {
        type: 'campoComponent', defaultValue: "", dataField: "listaCausaliScaricabili", dataType: "", caption: "Causali scaricabili",

        maxLength: '60',
        labelVisible: false,
        showInColumnChooser: false,
        width: '590px',
        dynamic: {
          dataSource: '',
          service: 'CausaleRifiutiSimple',
          autocomplete: false,
          valueExpr: '',
          displayExpr: '',
          caption: "Elenco causali di carico scaricabili",
          queryString: '',
          componentType: 'dynamicGrid',

          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'id',
            keyUnique: '',
            selectionMode: 'single',
            mode: 'cell',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: false,
            hoverStateEnabled: true,
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: false,
            searchAndSelect: true,
            searchAndSelectDataSource: '',
            outputData: false,
            height: 270,
            showColBlank: true,
            showFilterSearch: false,
            rowDragging: {
              allowReordering: true,
              showDragIcons: true
            },

          }


        }
      }
    ]
  }, */
  {
    itemType: "group", colCount: '1', groupWidth: 800, caption: "Elenco voci obbligatorie", class: 'lista-causali-scaricabili', groupDataField: 'causaliAvanzateScaricabili', data: [

      {
        type: 'campoGriglia', defaultValue: "", dataField: "vociObbligatorie", dataType: "", caption: "Causali scaricabili",

        nCol: 10,
        labelVisible: false,
        showInColumnChooser: false,
        formGrid: {
          service: 'CausaleRifiutiVociObbligatori',
          api: 'CampoRichiestoDocRifiuti',
          remoteOperation: true,
          queryString: '/$id',
          isEditable: true,
          isEditableNewRow: false,
          isEditableEditRow: true,
          isEditableDeleteRow: false,
          isOdata: false,
          showToolbarTop: false,
          showToolbarBottom: false,
          tableHeight: 460,
          tableWidth: 840,
          showFilter: false,
          selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
          idTable: 'CausaleRifiutiVociObbligatori',
          isSearchable: false,
          queryStringInEditor: '/$idCampoDocumentoRifiuto',
          isKeyID: false


        }

      }
    ]

  }

]


export const CausaleRifiuti: AnaColumn[] = [
  {
    configuration:
    {

      titleGriglia: 'Causali gestione rifiuti',
      titleForm: 'Configurazione causale $descCausale',
      campoTitle: ['descCausale'],
      helpDoc: 'ConfigurazioneCausaliGestioneRif.html',

      breadcrumbCaption: 'Gestione causale',

      service: 'CausaliRifiuti',
      api: 'CausaleRifiuti',
      filterList: '/',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 2,
      idTabRif: [
        {
          key: 'idCausale',
          value: 'id'
        },

      ],
      queryFilter: [

        {
          key: 'descCausale',
          value: 'descrizione'
        },
        {
          key: 'idCausale',
          value: 'id'
        },
      ]


    },
  },

  {
    itemType: "group", groupWidth: 750, colGroup: 5, colCount: '2', colSpan: 2, caption: "Definizione causale rifiuti", groupDataField: 'causaleRifiuti', class: 'mt-3',
    data: [
      {
        type: 'campo',
        dataField: "descrizione",
        dataType: "",
        caption: "Descrizione",
        colSpan: '2',
        maxLength: '60',

        validation: [
          { type: "required", message: "Il campo Descrizione obbligatoria" }
        ],
        orderGriglia: 1,
        nCol: 10,
      },
      {
        type: 'campoSpecial',
        dataField: 'idTipoOperazione',
        dataType: "",
        orderGriglia: 1,
        hideOnEdit: false,
        caption: "Tipo Operazione",
        colWidth: '466',
        maxLength: "2",
        editorType: 'dxSelectBox',
        nCol: 5,
        validation: [
          { type: "required", message: "Il campo Tipo Operazione obbligatorio" }
        ],
        lista: {
          dataSource: 'TipoOperazioneCausaleRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          cascading: ['id|idOperazione']
        },

      },
      {
        type: 'campoSpecial',
        dataField: 'idOperazione',
        dataType: "",
        nCol: 5,
        colVisible: false,
        caption: "Operazione",
        maxLength: "2",
        editorType: 'dxSelectBox',
        validation: [
          { type: "required", message: "Operazione obbligatoria" }
        ],
        lista: {
          dataSource: 'OperazioneCausaleRifiuti/GetAllByTipoOperazione',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?TipoOperazione=$idTipoOperazione',
          cascading: ['id|trasporto'],
          width: '500'
        },
        customTooltip: {
          typeContent: 'listaContent',
          content: '',
          dynamicContent: '$descrizione'
        },
      },
      {
        type: 'empty', dataType: '', caption: '', colSpan: '2'
      },


      {
        type: 'campoSpecial', dataField: 'prodottoDaGestione',
        colVisible: false,
        caption: 'Prodotto da gestione',
        disabled: true,
        nCol: 6,
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [
            {
              icon: 'glyphicon icon-unlocked',
              value: 'S',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: 'N',
              descrizione: 'No',
              alignment: 'center',
            },


          ]
        }


      },

      {
        type: 'campoSpecial', dataField: "trasporto", dataType: "", caption: "Trasporto a cura",
        maxLength: '15',
        editorType: 'dxSelectBox',
        orderGriglia: 3,
        nCol: 4,
        lista: {
          dataSource: 'TipoTrasporto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          filter: 'idOperazione',
          static: true,
        },
        validation: [
          { type: "required", message: "Trasporto Obbligatorio" }
        ],
      },

      {
        type: 'campoSpecial',
        dataField: "listaOperazioniRD",
        dataType: "",
        caption: "Op. Recup./Smaltimento",
        nCol: 10,
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        showInColumnChooser: false,

        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: '',
          caption: "Lista Operazioni Recupero e Smaltimento",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },




      {
        type: 'campo',
        dataField: 'operazione_Descrizione',
        dataType: "",
        colSpan: '2',
        colWidth: '1000',
        caption: "Operazione",
        hideOnEdit: true,
        colVisible: true,
        orderGriglia: 2,
        lista: {

          dataSource: 'OperazioneCausaleRIfiuti',
          valueExpr: 'descrizione',
          displayExpr: 'descrizione',
          static: false


        }
      },

    ],
  },
  //--------------------------------
  /*
   NonVisibie se
   SoloFuoriUL
    SoloSpurghi
    SoloPerRettificaGiacenza
    CreaCarichiDaRelazionare
    CreaCarichiDaLavorazione
 
  */
  {
    itemType: "group", colCount: '2', groupWidth: 350, colGroup: 2, groupDataField: 'altreInformazioni', class: " mt-4 altre-informazioni", caption: "Registri e MUD", data: [

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'stampaRegistriAziendali',
        dataType: "",
        colSpan: '2',
        caption: 'Stampa registri aziendali',
        hideOnEdit: false,
        editorType: 'dxRadioGroup',

        validation: [
          { type: "required", message: "Stampa registri aziendali Obbligatorio " }
        ],
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },

          ]
        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: 'stampaRegistriTerzi', dataType: "",
        colSpan: '2',
        caption: 'Stampa registri terzi',
        hideOnEdit: false,
        validation: [
          { type: "required", message: "Stampa registri terzi Obbligatorio" }
        ],
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'elaboraMUD',
        dataType: "",
        colSpan: '2',
        caption: 'Elabora MUD',
        hideOnEdit: false,
        validation: [
          { type: "required", message: "Elabora MUD obbligatorio" }
        ],
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },

      },
      {
        type: 'campoSpecial',
        colVisible: false,

        dataField: 'elaboraMUDTERZI',
        dataType: "",
        caption: 'Elabora MUD terzi',
        hideOnEdit: false,
        colSpan: '2',
        editorType: 'dxRadioGroup',
        validation: [
          { type: "required", message: "Elabora MUD terzi obbligatorio" }
        ],
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },
      },

    ]
  },
  {
    itemType: "group", colCount: '2', groupWidth: 500, colGroup: 2, groupDataField: 'altreInformazioni', class: " mt-4 altre-informazioni ", caption: "Altre Informazioni", data: [



      {
        type: 'campo',
        nCol: 3,
        colVisible: false,
        labelWidth: 100,
        dataField:
          'fatturazione',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Fatturazione',
        hideOnEdit: false,
      },
      {
        type: 'campo',
        nCol: 2,
        colVisible: false,
        labelWidth: 85,
        dataField: 'costi',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Costi',
        hideOnEdit: false,

      },
      { type: 'empty', dataType: '', colSpan: '2' },


      /* { type: 'campo', colVisible: false, dataField: 'barraSempreCaricoScarico', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Barra Sempre C/S', hideOnEdit: false, defaultValue: false }, */
      {
        type: 'campo',
        colVisible: false,
        labelWidth: 100,
        dataField: 'stampaMovimento',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Stampa movimento',
        hideOnEdit: false,
        colSpan: '2',
        nCol: 5,
      },
      {
        type: 'campo',
        colVisible: false,
        dataField: 'obbligoFuoriUL',
        nCol: 3,
        labelWidth: 100,
        disabled: true,
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Obbligo fuori UL',
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        disabled: true,
        dataField: 'spurghi',
        dataType: "boolean",
        labelWidth: 85,
        editorType: 'dxCheckBox',
        caption: 'Spurghi',
        readonly: true,
        nCol: 3,
        checkBox: {
          event: {
            type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
            key: 'setTrueSpurghi',
            value: [
              {
                optionName: 'trasporto',
                value: 'P'
              }
            ]

          }
        }
      },
      { type: 'empty', dataType: '', colSpan: '2' },
      {
        type: 'campo', colVisible: false, dataField: 'creaCarichiDaRelazionare', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Crea carichi da relazionare', hideOnEdit: true, defaultValue: false
      },
      {
        type: 'campo', colVisible: false, dataField: 'creaCarichiDaLavorazione', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Crea carichi da lavorazione', hideOnEdit: true, defaultValue: false
      },


    ]
  }
  //--------------------------------

]

//BACKUP 27/03/2024 

export const CausaleRifiutiBackup: AnaColumn[] = [
  {
    configuration:
    {

      titleGriglia: 'Causali gestione rifiuti',
      titleForm: 'Configurazione causale $descCausale',
      campoTitle: ['descCausale'],
      helpDoc: 'ConfigurazioneRegistridiCaricoeS.html',

      breadcrumbCaption: 'Gestione causale',

      service: 'CausaliRifiuti',
      api: 'CausaleRifiuti',
      filterList: '/',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 2,
      idTabRif: [
        {
          key: 'idCausale',
          value: 'id'
        },

      ],
      queryFilter: [

        {
          key: 'descCausale',
          value: 'descrizione'
        },
        {
          key: 'idCausale',
          value: 'id'
        },
      ]


    },
  },
  /* {
    itemType: "buttonMenu", colCount: "2", class: "col-12", caption: "", data: [
      {
        type: 'menuToolbar', dataField: 'posizioneCausale', orderGriglia: 1, colVisible: true, hideOnEdit: true, disableOnUpdate: true, buttons: [


          { name: 'Posizioni', icon: 'mdi mdi-settings-outline', displayMode: 'in-line', hint: 'Posizioni della causale', value: 'grid', location: 'top', visible: true, dataSource: 'PosizioneCausale', event: '3' },
          { name: 'Chiudi', icon: 'glyphicon icon-exit', displayMode: 'in-line', value: 'main', dataSource: '', costantValue: [{ key: 'close', value: true }], hint: 'Chiudi anagrafica', event: '5', location: 'top', visible: true },
          { name: 'Utility', icon: 'mdi mdi-settings-outline', displayMode: 'in-line', hint: 'Utility', event: "2", value: 'utility', location: 'bottom', visible: true },
        ]
      }
    ]
  }, */
  {
    itemType: "group", colCount: '2', colSpan: '2', caption: "Definizione causale rifiuti", class: 'causale-rifiuti', groupDataField: 'causaleRifiuti', data: [


      {
        type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione",
        colSpan: '2',
        maxLength: '60',
        colWidth: '466',
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        orderGriglia: 1,
      },


      {
        type: 'campoSpecial',
        dataField: 'idTipoOperazione',
        dataType: "",
        orderGriglia: 1,
        hideOnEdit: false,
        caption: "Tipo Operazione",
        colSpan: '2',
        maxLength: "2",
        editorType: 'dxSelectBox',
        groupIndex: 1,
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        lista: {
          dataSource: 'TipoOperazioneCausaleRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,

          cascading: ['id|idOperazione']

        }
      },


      {
        type: 'campoSpecial',
        dataField: 'idOperazione',
        dataType: "",
        colSpan: '2',

        colWidth: '1000',
        colVisible: false,
        caption: "Operazione",
        maxSize: 2,
        maxLength: "2",
        editorType: 'dxSelectBox',
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        lista: {

          dataSource: 'OperazioneCausaleRifiuti/GetAllByTipoOperazione',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?TipoOperazione=$idTipoOperazione',
          cascading: ['id|trasporto'],


        }
      },

      {
        type: 'campoSpecial', dataField: "trasporto", dataType: "", caption: "Trasporto a cura",
        maxLength: '15',
        maxSize: 15,
        width: '180px',
        colWidth: '135',
        editorType: 'dxSelectBox',
        colSpan: '2',
        orderGriglia: 3,
        lista: {
          dataSource: 'TipoTrasporto',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          filter: 'idOperazione',

          static: true,
        },
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
      },
      /* {
        type: 'campoSpecial', dataField: "prodottoDaGestione", dataType: "",
        caption: "Prodotto da gestione",
        defaultValue:'N',
        colSpan:'2',
        class:'prodotto-gestione',
        colVisible:true,
        maxLength: '25',
        maxSize: 25,
        editorType: 'dxSelectBox',
        disableOnUpdate: true,
        lista: {
          dataSource: 'prodottoDaGestione',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        },
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
      }, */
      {
        type: 'campoSpecial', dataField: 'prodottoDaGestione',
        colVisible: false,

        caption: 'Prodotto da gestione',
        class: 'allineaAlCentro radioGroupWithGaps d-none',
        colSpan: '2',


        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [
            {
              icon: 'glyphicon icon-unlocked',
              value: 'S',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: 'N',
              descrizione: 'No',
              alignment: 'center',
            },


          ]
        }


      },

      {
        type: 'campoSpecial',
        dataField: "listaOperazioniRDDesc",
        dataType: "",
        caption: "Op. Recup./Smaltimento",
        width: 100 + '%',
        colVisible: false,
        labelVisible: true,
        colSpan: '2',
        disableOnUpdate: true,
        showInColumnChooser: false,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,

          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Recupero e Smaltimento",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          related: ['listaOperazioniRD'],

          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: true,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },


      {
        type: 'campoSpecial', colVisible: false, dataField: "listaOperazioniRD",

        labelVisible: false,
        dataType: "",
        width: 8 * aspect,
        caption: "Mod. Stoccaggio ",
        class: 'd-none',
        disableOnUpdate: true,

        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          displayExpr: '',

          related: ['id|listaOperazioniRDDesc'],


        }

      },


      {
        type: 'campo',
        dataField: 'operazione_Descrizione',
        dataType: "",
        colSpan: '2',
        colWidth: '1000',
        caption: "Operazione",
        hideOnEdit: true,
        colVisible: true,
        orderGriglia: 2,
        lista: {

          dataSource: 'OperazioneCausaleRIfiuti',
          valueExpr: 'descrizione',
          displayExpr: 'descrizione',
          static: false


        }
      },

    ],
  },
  //--------------------------------
  /*
   NonVisibie se
   SoloFuoriUL
    SoloSpurghi
    SoloPerRettificaGiacenza
    CreaCarichiDaRelazionare
    CreaCarichiDaLavorazione
 
  */
  {
    itemType: "group", colCount: '2', groupDataField: 'altreInformazioni', class: " altre-informazioni", caption: "Registri e MUD", data: [

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'stampaRegistriAziendali',
        dataType: "",
        colSpan: '2',
        caption: 'Stampa registri aziendali',
        hideOnEdit: false,
        editorType: 'dxRadioGroup',

        validation: [
          { type: "required", message: "Stampa registri aziendali Obbligatorio " }
        ],
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },

          ]
        }
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: 'stampaRegistriTerzi', dataType: "",
        colSpan: '2',
        caption: 'Stampa registri terzi',
        hideOnEdit: false,
        validation: [
          { type: "required", message: "Stampa registri terzi Obbligatorio" }
        ],
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'elaboraMUD',
        dataType: "",
        colSpan: '2',
        caption: 'Elabora MUD',
        hideOnEdit: false,
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        editorType: 'dxRadioGroup',
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },

      },
      {
        type: 'campoSpecial',
        colVisible: false,

        dataField: 'elaboraMUDTERZI',
        dataType: "boolean",
        caption: 'Elabora MUD terzi',
        hideOnEdit: false,
        colSpan: '2',
        editorType: 'dxRadioGroup',
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        radioGroup: {

          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,

          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: '1',
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: '0',
              descrizione: 'No',
              alignment: 'center',
            },
          ]

        },
      },

    ]
  },
  {
    itemType: "group", colCount: '2', groupDataField: 'altreInformazioni', class: " altre-informazioni", caption: "Altre Informazioni", data: [



      { type: 'campo', colVisible: false, dataField: 'fatturazione', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Fatturazione', hideOnEdit: false, },
      {
        type: 'campo', colVisible: false, dataField: 'costi', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Costi', hideOnEdit: false,

      },

      /* { type: 'campo', colVisible: false, dataField: 'barraSempreCaricoScarico', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Barra Sempre C/S', hideOnEdit: false, defaultValue: false }, */
      {
        type: 'campo', colVisible: false, dataField: 'stampaMovimento', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Stampa movimento', hideOnEdit: false,
        colSpan: '2'
      },

      /**Non Visibile se */

      {
        type: 'campo', colVisible: false, dataField: 'obbligoFuoriUL',
        class: 'd-none',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Obbligo fuori UL',
      },
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: 'spurghi',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        hideOnEdit: false,
        caption: 'Spurghi',
        class: 'd-none',
        checkBox: {
          event: {
            type: 'emittedEvent', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
            key: 'setTrueSpurghi',
            value: [
              {
                optionName: 'trasporto',
                value: 'P'
              }
            ]

          }
        }
      },

      {
        type: 'campo', colVisible: false, dataField: 'creaCarichiDaRelazionare', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Crea carichi da relazionare', hideOnEdit: true, defaultValue: false
      },
      {
        type: 'campo', colVisible: false, dataField: 'creaCarichiDaLavorazione', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Crea carichi da lavorazione', hideOnEdit: true, defaultValue: false
      },


    ]
  }
  //--------------------------------

]